import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getCompanyList, doLogin } from "../../actions/auth";
import compose from "recompose/compose";


const styles = (theme) => ({
  pageContainer: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    fontWeight: '500'
  }
});

export class Login extends Component {
  state = {
    username: "",
    password: "",
    usernameError: false,
    passwordError: false,
  };

  static propTypes = {
    login: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
  };

  componentDidMount() {
    let search = (this.props.location.search) || ''
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('token=') == 0
    })
    if (obj) {
      let token = obj.split('=')[1]
      if (token) { //自动登录
        getCompanyList(token).then(resp => {
          let list = resp.result || []
          let companyList = list.map(v => {
            return {
              ...v.application,
              ...v.company
            }
          })
          if (list.length > 0) {
            let data = list[0]
            let company = data.company ? data.company.company_name : ''
            localStorage.setItem('applicationList', JSON.stringify(companyList))
            localStorage.setItem('applicationName', data.application.application_name)
            localStorage.setItem('companyName', company)
            this.props.doLogin(true, {
              access: token,
              refresh: token,
              ...data.application,
            })
          } else {
            this.props.doLogin(false, {
              access: token,
              refresh: token,
            })
          }
        })



      }
    }
  }

  render() {
    if (this.props.isAuthenticated && this.props.company_name) {
      return <Redirect to="/" />;
    }
    const classes = this.props.classes;
    return (
      <div className={classes.pageContainer}>
        Loading...
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  company_name: state.auth.company_name,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, { doLogin })
)(withRouter(Login));
